import { useChangeIsChildPresented } from "@/queries/images/use-change-is-child-presented";
import { useImageById } from "@/queries/images/use-image-by-id";
import { useEffect, useState } from "react";

export function useIsChildPresent(imageId: string, disabled: boolean) {
  const { data: imageData } = useImageById(imageId);
  const { mutate: changeIsChildPresented, error: changeIsChildPresentedError } =
    useChangeIsChildPresented(imageId);

  const [isChildPresent, setIsChildPresent] = useState(
    imageData?.isChildPresented || false
  );

  useEffect(() => {
    if (imageData) {
      setIsChildPresent(imageData.isChildPresented);
    }
  }, [imageData]);

  function toggleIsChildPresent() {
    if (disabled || !imageData) {
      return;
    }
    const newValue = !isChildPresent;
    setIsChildPresent(newValue);
    changeIsChildPresented(
      {
        isChildPresented: newValue,
      },
      {
        onError: () => {
          setIsChildPresent(imageData.isChildPresented);
        },
      }
    );
  }

  return { isChildPresent, toggleIsChildPresent, error: changeIsChildPresentedError };
}
